import moment from "moment";
export const convertHexBalanceToDecimal = (hex, decimal) => {
  return parseInt(hex.toString()) / Math.pow(10, decimal);
};

export const convertDecimalToHexBalance = (value, decimal) => {
  return parseInt(value) * Math.pow(10, decimal);
};

export const formatMoney = (money, coefficient = 3) =>
  money?.toLocaleString("en-US", { minimumFractionDigits: coefficient });

export const formatter = (value) => {
  if (!value) return '0'
  const valueFinal = parseFloat(value).toString()
  const values = valueFinal.split('.');
  values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return values.join('.')
};
const getYearOfReward = (monthReward) => {
  const months = monthReward.split(" ")[0];
  const year = months / 12;
  return [year, year <= 1 ? "year" : "years"];
};

export const convertDataStake = (stake, decimal = 8) => {
  const timeStartStake = parseFloat(stake[4].toString()) * 1000;
  const unlockAt = parseFloat(stake[5].toString()) * 1000;
  const dateTimeCurrent = new Date().getTime();
  // const startDateStake = moment(timeStartStake)
  const dataPlan = stake[3].toString().split(",");
  const duration = parseFloat(dataPlan[2]) * 1000;
  const [year, label] = getYearOfReward(dataPlan[1]);
  const isActive = timeStartStake + duration > dateTimeCurrent;
  const isFinish = timeStartStake + duration < dateTimeCurrent;
  return {
    id: stake[0].toString(),
    amount: convertHexBalanceToDecimal(stake[1].toString(), decimal),
    idPlan: dataPlan[0].toString(),
    year,
    timeStartStake,
    label,
    duration,
    wardsRate: parseFloat(dataPlan[3]),
    ratioGetTokenStaking: parseFloat(dataPlan[4]),
    isActive,
    isFinish,
    isClose: unlockAt > 0,
  };
};

export const getClassStatustItemStake = (item) => {
  if (item.isClose) {
    return "Closed";
  }
  if (item.isFinish) {
    return "Finished";
  }
  if (item.isProcess) {
    return "Process";
  }
  if (item.isActive) {
    return "Active";
  }
};

export const convertDataRewardPlan = (rewardPlan) => {
  const value = rewardPlan[0].toString();
  const [year, label] = getYearOfReward(rewardPlan[1].toString());
  return {
    id: value,
    year,
    label,
    duration: parseFloat(rewardPlan[2].toString()),
    wardsRate: parseFloat(rewardPlan[3].toString()),
    ratioGetTokenStaking: parseFloat(rewardPlan[4].toString()),
  };
};

export const calculateVotingPower = ({ token, ratio }) => {
  return (token * ratio) / 100;
};

export const splitAddressWallet = (address, font = 6, end = 4) => {
  return (
    address.substring(0, font) + "..." + address.substring(address.length - end)
  );
};
